import Backbone from 'backbone';
import model from 'models/admin/userModel';
const UserCollection = Backbone.Collection.extend({
    url: '/api/user',
    model,
    parse(data) {
        const that = this;

        if (data) {
            that.add(data.hasOwnProperty('data') ? data.data : data);
        }
        return this.models;
    },

    total: 0,
    getUsers(url, collection, successFn, errorFn) {
        const that = this;
        collection.fetch({
            url,
            success(data, response) {
                that.total = response.total;
                that.add(collection.models);
                successFn();
            },
            error() {
                errorFn();
            },
        });
    },
    comparator(model) {
        return -model.attributes.created;
    },
});
export default UserCollection;
